import React from 'react'
import styled from 'styled-components'

const Button = ({children, as: Tag = 'button', size = "lg", kind = "orange", addArrow = false, ...props }) => {

  const classNames = `engager-btn btn-${size} btn-${kind} ${addArrow ? "add-arrow" : ""} ${props.className}`

  return (
    <ButtonWrapper as={Tag} {...props} className={classNames}>
      <span>{children}</span>
      {addArrow &&
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          stroke="currentColor"
          className="arrow"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      }
    </ButtonWrapper>
  )
}

export default Button;

const ButtonWrapper = styled.div`
  display: inline-block;
  font-weight: 500;
  text-align: center;
  justify-content: center;
  white-space: nowrap;
  user-select: none;
  line-height: 1.3;
  border-radius: 10px;
  -webkit-appearance: none;
  transition: all .3s ease-in-out;
  text-decoration: none;
  background-color: #F58220;
  color: #fff;
  padding: 15px 40px;
  font-size: 18px;
  cursor: pointer;
  border: none;
  
  &:hover,
  &:focus {
    text-decoration: none;
    color: #fff;
    background-color: #e56f0a;
    outline: none;
  }
  
  &.btn-gray {
     background-color: #F4F3F1;
     color: #000;
     
    &:hover,
    &:focus {
      color: #000;
      background-color: #EEEEEE;
    }
  }
  
  &.btn-sm {
    font-size: 14px;
    padding: 16px 20px;
  }
  
  &.btn-md {
    font-size: 16px;
    padding: 14px 30px;
  }
  
  &.disabled,
  &:disabled {
    background-color: #f8f7f6;
    color: #ABABBA;
    border-color: #F4F3F1;
    pointer-events: none;
  }
  
  &.add-arrow {
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    .arrow {
      margin-left: 10px;
      margin-right: -3px;
    }
  }
`;


// WEBPACK FOOTER //
// ./src/components/ui/button.js